import { apiRequest } from './client';
import type { OnboardingState, UpdateOnboardingStepInput, UUID } from '@/types';

export const onboardingApi = {
  getState(tenantId: UUID): Promise<OnboardingState> {
    return apiRequest(`/api/v1/tenants/${tenantId}/onboarding`, { tenantId });
  },

  updateStep(tenantId: UUID, input: UpdateOnboardingStepInput): Promise<OnboardingState> {
    return apiRequest(`/api/v1/tenants/${tenantId}/onboarding`, {
      method: 'PUT',
      body: input,
      tenantId,
    });
  },

  complete(tenantId: UUID): Promise<OnboardingState> {
    return apiRequest(`/api/v1/tenants/${tenantId}/onboarding/complete`, {
      method: 'POST',
      tenantId,
    });
  },
};
